import { API_ENDPOINTS } from "./apiCall";

const API_BASE_URL = API_ENDPOINTS.API_COMMAN_URL +'Sales/';

export const SALES_API_ENDPOINTS = {
    SAMPLE_PRICELIST: `${API_BASE_URL}get-sample-price-list`,
    GetAllCOList: `${API_BASE_URL}GetAllCOLists`,
    COMANAGEMENT_GET_SELECTED_CO_DETAILS: `${API_BASE_URL}GET_SELECTED_CO_DETAILS`,
    GET_MASTER_LIST: `${API_BASE_URL}getMasterList`,
   ORDERMANAGEMENT_VALIDATE_EXCEL_BULK_UPLOAD: `${API_BASE_URL}ValidateExcelData1`,

    despatch:{
         list: `${API_BASE_URL}despatch-plan-list`,
         co_list: `${API_BASE_URL}confirmation-order-list`,
         list_by_id:`${API_BASE_URL}user_guide-list-by-id`,
    }

};
